import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WorkflowTaskControl from './Controls/WorkflowTaskControl';

const TaskView: React.FC = () => {
    const [taskId, setTaskId] = useState<number>();
    const navigate = useNavigate()

    let id = useParams().id;

    useEffect(() => {
        if (id)
            setTaskId(parseInt(id))
    }, [id])

    function onTaskSubmited(newTaskId?: number) {
        if (newTaskId) {
            let url = '/plm/Workflow/Task/' + newTaskId;
            navigate(url);
        }
    }

    if (taskId)
        return <WorkflowTaskControl taskId={taskId} onTaskSubmitted={onTaskSubmited} />
    else
        return <></>
}
export default TaskView;